import { render, staticRenderFns } from "./InvoicePurchase.vue?vue&type=template&id=dbde021e&"
import script from "./InvoicePurchase.vue?vue&type=script&lang=js&"
export * from "./InvoicePurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports